<form>
  <!-- Modal Header -->
  <div class="modal-header" style="background-color: aquamarine" [hidden]="isModal == false">
    <h4 class="modal-title">Assign Commission</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div [ngClass]="isModal == false ? 'p-3' : 'modal-body'">
    <div [hidden]="commissionList.length >= 0">
      <p>You do not have any unassigned commission.</p>
    </div>

    <div [hidden]="commissionList.length == 0">
      <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter(searchText)" placeholder="Enter searching criteria" [(ngModel)]="searchText" name="searchText" />
          </mat-form-field>
          <button class="btn btn-light ms-1" (click)="setFilter('')"><i class="fas fa-times"></i></button>
        </div>
        <div class="col">
          <!-- <p class="my-0 py-0">Last Date</p> -->
          <mat-form-field class="full-width-formField p-0">
            <mat-label>Last Date</mat-label>
            <input matInput readonly [matDatepicker]="lastDatePicker" name="date" [(ngModel)]="lastDate" required />
            <mat-datepicker-toggle matSuffix [for]="lastDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #lastDatePicker name="date"></mat-datepicker>
          </mat-form-field>
          <button class="btn btn-light ms-1" (click)="lastDate = undefined"><i class="fas fa-times"></i></button>
        </div>

        <div class="col">
          <button class="btn btn-danger" type="button" [hidden]="loggedInRole != enums.BRANCH_MANAGER" (click)="confirmBeforeAssignAll()"><i class="fas fa-trash-alt"></i> Clear Commission</button>
        </div>
      </div>

      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>
          <!-- Customer Name Column -->
          <ng-container matColumnDef="CustomerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
            <td mat-cell *matCellDef="let commission">
              <p>
                <button class="btn btn-light btn-sm" (click)="setFilter(commission.CustomerName)"><i class="fas fa-filter"></i></button> <span class="customerNameText" (click)="goToCustomer(commission.CustomerId)"> {{ commission.CustomerName }} </span>
              </p>
            </td>
          </ng-container>

          <!-- Principal Column -->
          <ng-container matColumnDef="Principal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Principal</th>
            <td mat-cell *matCellDef="let commission">
              {{ commission.Principal }}
            </td>
          </ng-container>

          <!-- Company Code Column -->
          <ng-container matColumnDef="CompanyCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CompanyCode Code</th>
            <td mat-cell *matCellDef="let commission">
              <p>
                <button class="btn btn-light btn-sm" (click)="setFilter(commission.CompanyCode)"><i class="fas fa-filter"></i></button> <span class="customerNameText" (click)="goToCustomer(commission.CustomerId)"> {{ commission.CompanyCode }} </span>
              </p>
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
            <td mat-cell *matCellDef="let commission; let i = index">
              @if (commission.Assigned == false) {
                <btn class="btn btn-primary" (click)="addCommission(commission, i)"> Assign</btn>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[100, 200, 300]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>
</form>
